/*
 * File: ReferralHandler.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Manages state to fetch a referral by id from the api
 */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Api from "../Api";

const ReferralHandler = ({ children, referralId }) => {
  const [loading, setLoading] = useState(true);
  const [referral, setReferral] = useState(null);

  useEffect(() => {
    const fetchReferral = async () => {
      try {
        const ref = await Api.find(referralId);
        setLoading(false);
        setReferral(ref);
        // referral not found
      } catch (e) {
        setLoading(false);
        setReferral(null);
      }
    };
    fetchReferral();
  }, [referralId]);

  return React.cloneElement(children, { loading: loading, referral: referral });
};

ReferralHandler.propTypes = {
  children: PropTypes.object,
  referralId: PropTypes.number
};

export default ReferralHandler;
